import { render, staticRenderFns } from "./AddDashboard.vue?vue&type=template&id=23886554"
import script from "./AddDashboard.vue?vue&type=script&lang=js"
export * from "./AddDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports